import { GlobalResponseObject } from "../../common";
import { LatestQuestionsModel } from "./latest-questions.model";

export class LatestQuestionBankResponse extends GlobalResponseObject {
    data: LatestQuestionsModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data: LatestQuestionsModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}